import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportHelpModalComponent } from './report-help-modal.component';



@NgModule({
  declarations: [ReportHelpModalComponent],
  imports: [
    CommonModule
  ],
  exports: [ReportHelpModalComponent],
})
export class ReportHelpModalModule { }
